import type { IPlace } from "@bbj-types/address";

export const isOptionEqualToValue = (placeA: IPlace, placeB: IPlace) => {
  return placeA.placeLabel === placeB.placeLabel;
};

export const getOptionLabel = (option: IPlace) => {
  const { placeLabel, postalCodes } = option;
  return [placeLabel, postalCodes ? postalCodes[0] : undefined].filter(Boolean).join(" - ");
};
